module.exports = __webpack_public_path__ + "static/media/_DSC6081.479305fb.jpg";